'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlEscapePress', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.bind("keydown", function (event) {
        if (event.which === 27) {
          $scope.$apply(function () {
            $scope.$eval($attrs.tlEscapePress);
          });
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlEscapePress.js
// module id = 2901
// module chunks = 13